import { render, staticRenderFns } from "./AdvertisementCarousel.vue?vue&type=template&id=581be76c&scoped=true&"
import script from "./AdvertisementCarousel.vue?vue&type=script&lang=js&"
export * from "./AdvertisementCarousel.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementCarousel.vue?vue&type=style&index=0&id=581be76c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581be76c",
  null
  
)

export default component.exports